import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import BigNumber from 'bignumber.js';
import { FormValue } from '../type';
import { usePairsByIndex } from '../hooks/usePairsByIndex';
import { usePreviewTpSl } from '../hooks/usePreviewPnl';
import { FEES } from '@/constans/trade';
import { formatDisplay } from '@/utils/format-display';

export function Footer() {
    const { control } = useFormContext<FormValue>();
    const { liqPrice } = usePreviewTpSl();
    const { t } = useTranslation();
    const [amount, leverage, pairIndex] = useWatch({
        control,
        name: ['amount', 'leverage', 'pairIndex'],
    });
    const pair = usePairsByIndex(pairIndex);

    const PositionSize = useMemo(() => {
        return new BigNumber(amount || 0).multipliedBy(leverage).toNumber();
    }, [amount, leverage]);

    const fee = useMemo(() => {
        if (!pair?.groupName) return '--';
        const feeRate = FEES[pair.groupName] * (pair?.feeRate ?? 1);
        return formatDisplay((Number(amount) * leverage * feeRate) / 100, {
            decimalToShow: 2,
        });
    }, [amount, leverage, pair?.feeRate, pair?.groupName]);

    return (
        <div className="text-center">
            <p className="text-[10px] text-slate-400 font-medium whitespace-nowrap">
                <span>
                    {t('Position Size')}: {formatDisplay(PositionSize || 0)} WLD{' '}
                </span>
                <span className="mx-1 text-slate-300">|</span> {t('Fees')}: ~
                {fee} USD <span className="mx-1 text-slate-300">|</span>{' '}
                {t('Liq Price')}: {formatDisplay(Number(liqPrice || 0))}
            </p>
        </div>
    );
}
